import React, {FC} from "react";
import {Col, Descriptions, Row, Table} from "antd";
import {IResultData, IResultProps} from "./express-help-client-questionnaire.type";
import {getNameByLang, localize} from "mixins/helpers";
import DownloadIcon from "mixins/ui/icons/download.svg"
import dayjs from 'mixins/dayjsConfig.js';
import Button from "mixins/ui/button/button";

const Result: FC<IResultProps> = (props: IResultProps) => {
    const dataSource = Object.values(props.data).map((x: IResultData) => ({
        number: x.number,
        question: getNameByLang(x.question, props.language === 'en_150' ? 'kk_KZ' : props.language, 'question'),
        answer: getNameByLang(x.answer, props.language === 'en_150' ? 'kk_KZ' : props.language, 'answer'),
    }));

    const columns = [
        {
            title: '№',
            dataIndex: 'number',
            key: 'number',
        },
        {
            title: localize('express-help-question', props.translations),
            dataIndex: 'question',
            key: 'question',
        },
        {
            title: localize('express-help-answer', props.translations),
            dataIndex: 'answer',
            key: 'answer',
        },
    ];

    return (
        <>
            <div className="express-help-client-questionnaire__result-header">
                <Row justify="space-between">
                    <Col className="express-help-client-questionnaire__result-header-title">
                        {localize('express-help-online-test-results', props.translations)}
                    </Col>
                    <Col className="express-help-client-questionnaire__result-header-date">
                        {localize('data', props.commonTranslations)}: {dayjs().format("DD.MM.YYYY")}
                    </Col>
                    <Col span={24} className="express-help-client-questionnaire__result-header-questionnaire">
                        {getNameByLang(props.questionnaire, props.language === 'en_150' ? 'kk_KZ' : props.language, 'questionnaire')}
                    </Col>
                </Row>
            </div>

            <div className="express-help-client-questionnaire__result-body">
                <Table dataSource={dataSource} columns={columns} bordered pagination={false} />
            </div>

            <div className="express-help-client-questionnaire__result-data">
                <Descriptions title={localize('express-help-result', props.translations)} bordered column={1} className="mb-4">
                    {props.resultData.map(x => (
                        <Descriptions.Item label={getNameByLang(x.resultType, props.language === 'en_150' ? 'kk_KZ' : props.language, 'resultType')}>
                            {getNameByLang(x, props.language === 'en_150' ? 'kk_KZ' : props.language, 'result')}
                        </Descriptions.Item>
                    ))}
                </Descriptions>

                <hr />

                <Row gutter={25}>
                    <Col>
                        <Button onClick={() => open(`${props.siteUrl}/pages/info-services/express-help`, '_self')}>
                            {localize('express-help-back-to-q', props.translations)}
                        </Button>
                    </Col>
                    <Col>
                        <Button onClick={() => open(`${props.siteUrl}/pages/info-services/express-help/interview?id=${props.questionnaireId}`, '_self')}>
                            {localize('express-help-start-test-again', props.translations)}
                        </Button>
                    </Col>
                    <Col>
                        <Button type="default" icon={<DownloadIcon />}>
                            {localize('button.download', props.commonTranslations)}
                        </Button>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default Result;
